import gql from 'graphql-tag'

// 上传历史列表
export const getTextractTasks = gql`
  query($paging: PagingQuery, $order: TextractTasksOrder) {
    getTextractTasks(
      paging: $paging,
      order: $order,
    ) {
      textractTasks {
        id
        jobId
        name
        requestToken
        jobStatus
        storeKey
        type
        createdAt
        updatedAt
        createdBy {
          id
          username
        }
        recognizedContent {
          form {
            key
            value
          }
          table {
            header
            body
            rowNum
            columnNum
          }
        }
        presumedPolicies {
          id
          policyName
          term
        }
        presumedAccounts {
          id
          name
        }
        additionalInfoStr
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`
// 查询识别状态
export const getTextractTaskStatus = gql`
  query($textractTaskId: Int!) {
    getTextractTaskStatus(
      textractTaskId: $textractTaskId
    )
  }
`
// """新建 TextractTask"""
export const newTextractTask = gql`
  mutation($input: TextractTaskInput!) {
    newTextractTask(
      input: $input
    ) {
      id
      jobId
    }
  }
`
// 根据id查找识别内容
export const getTextractTask = gql`
  query($textractTaskId: Int!) {
    getTextractTask(
      textractTaskId: $textractTaskId,
    ) {
        id
        jobId
        name
        requestToken
        jobStatus
        type
        createdAt
        updatedAt
        createdBy {
          id
          username
        }
        recognizedContent {
          form {
            key
            value
          }
          table {
            header
            body
            rowNum
            columnNum
          }
        }
        presumedPolicies {
          id
          policyName
        }
        presumedAccounts {
          id
          name
        }
        additionalInfoStr
    }
  }
`
// """读取 textract 识别出的文档内容"""
export const createStatementByTextract = gql`
  mutation($month: String, $textractId: Int!) {
    createStatementByTextract(
      month: $month
      textractId: $textractId
    ) {
      id
    }
  }
`
